import { classificationScopesEnum } from "helpers/enums";
import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/classificationTypes";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(
        `${resource}/getList?withDeleted=true&${query.substring(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};
const list = (params: {}, filterParams?: OdataFilters) =>
    request(`${resource}/getList${containsQuery(params, filterParams)}`, { method: "GET" });
const singleList = (params: {}) => list(params, { filter: { scope: classificationScopesEnum.Single } });
const periodList = (params: {}) => list(params, { filter: { scope: classificationScopesEnum.Period } });
const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));
const getItem = ({ id }: { id: string }) => request(`${resource}/get/${id}`, { method: "GET" });

export { apply, delItem, index, getItem, restore, list, singleList, periodList };
